// Phase 6 — Track E T-E3. NavigationBar primitive (hand-rolled).
//
// Top navbar shell — a `<header>` with a `<nav role="navigation">` slot.
// The real NavBar (Track C dispatch — `web/src/components/NavBar.tsx`)
// composes this primitive + AlertBell + ThemeToggle + UserMenu. This
// primitive handles only the structural shell + the keyboard-tab order
// (skip link to main, then nav items).

import * as React from 'react';
import { cn } from '../../lib/cn.js';

export interface NavigationBarProps extends React.HTMLAttributes<HTMLElement> {
  /** Optional skip-to-main-content target id, default `main`. */
  skipTargetId?: string;
}

export const NavigationBar = React.forwardRef<HTMLElement, NavigationBarProps>(
  ({ className, children, skipTargetId = 'main', ...props }, ref) => (
    <header
      ref={ref}
      className={cn(
        'sticky top-0 z-40 w-full border-b border-border-subtle bg-surface-base/80 backdrop-blur-md',
        className,
      )}
      {...props}
    >
      <a
        href={`#${skipTargetId}`}
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-2 focus:z-50 focus:rounded focus:bg-surface-overlay focus:px-3 focus:py-1 focus:text-body-strong focus:shadow"
      >
        Skip to main content
      </a>
      <nav role="navigation" aria-label="Primary" className="mx-auto flex h-14 max-w-7xl items-center gap-4 px-4">
        {children}
      </nav>
    </header>
  ),
);
NavigationBar.displayName = 'NavigationBar';
